import { render, staticRenderFns } from "./FundingRequestAutoProcessed.vue?vue&type=template&id=5fa87807&scoped=true&"
import script from "./FundingRequestAutoProcessed.vue?vue&type=script&lang=js&"
export * from "./FundingRequestAutoProcessed.vue?vue&type=script&lang=js&"
import style0 from "./FundingRequestAutoProcessed.vue?vue&type=style&index=0&id=5fa87807&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fa87807",
  null
  
)

export default component.exports